module.exports = __webpack_public_path__ + "assets/img/container-ios1.5b6d6ac.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/container-ios1.png
// module id = TepT
// module chunks = 50